import { Card, CardContent } from "@/components/ui/card";
import { Sparkles } from "lucide-react";
import { ReactNode } from "react";

interface EmptyApiStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  className?: string;
}

export function EmptyApiState({ title, description, icon, className }: EmptyApiStateProps) {
  return (
    <Card className={className}>
      <CardContent className="flex flex-col items-center justify-center gap-2 py-10 text-center">
        <div className="rounded-full bg-muted p-3 text-muted-foreground">
          {icon ?? <Sparkles className="h-5 w-5" aria-hidden="true" />}
        </div>
        <h3 className="text-sm font-medium">{title}</h3>
        {description && (
          <p className="max-w-md text-xs text-muted-foreground">{description}</p>
        )}
        <span className="mt-1 inline-flex items-center rounded-full bg-muted px-2 py-0.5 text-[11px] font-medium text-muted-foreground">
          Awaiting backend API
        </span>
      </CardContent>
    </Card>
  );
}

export default EmptyApiState;
